import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { H2 } from "commons";

import { WARNING as WARNING_SEVERITY } from "../../helpers/ErrorHelpers";
import { READONLY_MESSAGE } from "../../constants/messageText";
import { Message } from "../../components/Message";
import { ChangePasswordContainer } from "./ChangePasswordContainer";
import { DocumentPreferencesContainer } from "./DocumentPreferences/DocumentPreferencesContainer";

export function Settings({ isAdviser }) {
    return (
        <>
            <Message severity={WARNING_SEVERITY} text={READONLY_MESSAGE} shown={isAdviser} />
            <StyledH2 secondary textAlign="center">
                Settings
            </StyledH2>
            <ChangePasswordContainer />
            <DocumentPreferencesContainer />
        </>
    );
}

const StyledH2 = styled(H2)`
    margin: 1rem 0 1rem 0;
`;

Settings.propTypes = {
    isAdviser: PropTypes.bool
};
